import { RouteObject } from "react-router-dom";
import { AppointmentActionTypeSelectionScreen } from "./AppointmentActionTypeSelectionScreen";
import { AppointmentContactScreen } from "./AppointmentContactScreen";
import { AppointmentDepartmentSelectionScreen } from "./AppointmentDepartmentSelectionScreen";
import { AppointmentModificationTimeAndDate } from "./AppointmentModificationTimeAndDate";
import { AppointmentNoRecipeScreen } from "./AppointmentNoRecipeScreen";
import { AppointmentNotPossibleScreen } from "./AppointmentNotPossibleScreen";
import { AppointmentPhoneNumberScreen } from "./AppointmentPhoneNumberScreen";
import { AppointmentPhoneVerificationScreen } from "./AppointmentPhoneVerificationScreen";
import { AppointmentPracticeSelectionScreen } from "./AppointmentPracticeSelectionScreen";
import { AppointmentPreferencesScreen } from "./AppointmentPreferencesScreen";
import { AppointmentRecipeInfoScreen } from "./AppointmentRecipeInfoScreen";
import { AppointmentRecipeUploadScreen } from "./AppointmentRecipeUploadScreen";
import { AppointmentSelfPayerAdditionalTreatmentsScreen } from "./AppointmentSelfPayerAdditionalTreatmentsScreen";
import { AppointmentSelfPayerDurationScreen } from "./AppointmentSelfPayerDurationScreen";
import { AppointmentSuccessScreen } from "./AppointmentSuccessScreen";
import { AppointmentTimeSlotScreen } from "./AppointmentTimeSlotScreen";
import { AppointmentUnavailableScreen } from "./AppointmentUnavailableScreen";

/**
 * Shared appointment route children
 * Used by both the main App router and the Widget router
 */
export const appointmentRouteChildren: RouteObject[] = [
  {
    path: "practice",
    element: <AppointmentPracticeSelectionScreen />,
  },
  {
    path: "department",
    element: <AppointmentDepartmentSelectionScreen />,
  },
  {
    path: "type",
    element: <AppointmentActionTypeSelectionScreen />,
  },
  {
    path: "phoneNumber",
    element: <AppointmentPhoneNumberScreen />,
  },
  {
    path: "phoneVerification",
    element: <AppointmentPhoneVerificationScreen />,
  },
  {
    path: "cancellationAppointmentContact",
    element: <AppointmentContactScreen />,
  },
  {
    path: "cancellationAppointmentDateTime",
    element: <AppointmentModificationTimeAndDate />,
  },
  {
    path: "modificationAppointmentTimeSlots",
    element: <AppointmentTimeSlotScreen />,
  },
  {
    path: "modificationAppointmentContact",
    element: <AppointmentContactScreen />,
  },
  {
    path: "modificationAppointmentDateTime",
    element: <AppointmentModificationTimeAndDate />,
  },
  {
    path: "recipeInfo",
    element: <AppointmentRecipeInfoScreen />,
  },
  {
    path: "recipe",
    element: <AppointmentRecipeUploadScreen />,
  },
  {
    path: "noRecipe",
    element: <AppointmentNoRecipeScreen />,
  },
  {
    path: "selfPayerDuration",
    element: <AppointmentSelfPayerDurationScreen />,
  },
  {
    path: "selfPayerAdditionalTreatments",
    element: <AppointmentSelfPayerAdditionalTreatmentsScreen />,
  },
  {
    path: "timeSlot",
    element: <AppointmentTimeSlotScreen />,
  },
  {
    path: "contact",
    element: <AppointmentContactScreen />,
  },
  {
    path: "success",
    element: <AppointmentSuccessScreen />,
  },
  {
    path: "preferences",
    element: <AppointmentPreferencesScreen />,
  },
  {
    path: "appointmentNotPossible",
    element: <AppointmentNotPossibleScreen />,
  },
  {
    path: "appointmentUnavailable",
    element: <AppointmentUnavailableScreen />,
  },
];
